import { render, staticRenderFns } from "./WithdrawDataInfo.vue?vue&type=template&id=bc0163e6&"
import script from "./WithdrawDataInfo.vue?vue&type=script&lang=js&"
export * from "./WithdrawDataInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports